

const Home = () => {
    return(
        <div>
            <h1>This is Stock Page</h1>
        </div>
    )
}

export default Home;